import React from 'react'
import { DropdownSection } from 'live/components/ui/dropdown-toggler'
import i18n from 'live/services/i18n'
import Configs from './configs'
import _ from 'lodash'
import styled from 'styled-components'
import theme, { darkMode } from 'live/services/theme'
import {
    Title as ChannelTitle,
    Label as ChannelName,
    SelectedOptionContainer as FullHeightSelectorClosedSelectedOptionContainer
} from 'live/components/ui/full-height-selector/full-height-selector-closed'
import {
    FullHeightSelectorOpenContainer,
    OptionList,
    InputContainer as Filter
} from 'live/components/ui/full-height-selector/full-height-selector-open'
import {
    ButtonStyle as DropdownButtonStyle,
    ColorDropdownOptionsContainer,
    ColorPickerContainer,
    MenuContainer
} from 'plugin-assets/shared/components/color-dropdown-options'
import { ChannelRelativeContainer, LabelBlockedAsset } from './channels-config'
import { ValueStyleContainer, UnitStyleContainer } from './chart-config/chart-config'
import { FormattingConfigContainer } from './chart-config/formatting-config'
import { PercentageInputContainer } from 'live/components/forms/ui/slider-with-input'
import { TabSelectorBackground } from 'plugin-assets/shared/widget/components/tab-selector'

darkMode.ResizeIconSmall = theme['darker-borders']

class DashboardActions extends React.Component<ChannelsValueTypeActionProps> {
    render() {
        const selectedAsset = _.get(this.props.widgetConfig, 'assets[0]', null)

        return (
            <DashboardActionsContainer
                direction="column"
                align="stretch"
                boundarySelector=".dashboard-content-container"
            >
                {!selectedAsset ? (
                    <label className="mb-5">{i18n("The asset wasn't found.")}</label>
                ) : (
                    <Configs
                        widgetConfig={this.props.widgetConfig}
                        changeConfig={this.props.changeConfig}
                        changeLayoutConfig={this.props.changeConfig}
                        type="channels-value"
                        colorPickerPosition="right"
                    />
                )}
            </DashboardActionsContainer>
        )
    }
}

const DashboardActionsContainer = styled(DropdownSection)`
    max-height: unset;
    overflow: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    ::-webkit-scrollbar {
        width: 0;
        height: 0;
    }
    padding: 0;
    min-height: fit-content;
    align-items: stretch;
    && ${ChannelName} {
        color: var(--static-gray-0);
    }
    && ${ChannelTitle} {
        color: var(--static-gray-0);
    }
    ${OptionList} {
        ::-webkit-scrollbar-thumb:vertical {
            background-color: ${({ theme }) => theme['dark-bg']};
        }
    }
    ${Filter} {
        border: solid 1px ${({ theme }) => theme['darker-borders']};
        background: ${({ theme }) => theme['dark-bg']};
        input {
            background: ${({ theme }) => theme['dark-bg']};
            color: ${({ theme }) => theme.white};
        }
    }
    && ${FullHeightSelectorClosedSelectedOptionContainer} {
        background-color: var(--static-gray-900);
        border: 1px solid var(--static-gray-1000);
        color: var(--static-gray-0);
    }
    && ${FullHeightSelectorOpenContainer} {
        background-color: var(--static-gray-800);
        > div {
            background-color: var(--static-gray-900);
            border: 1px solid var(--static-gray-1000);

            input {
                background-color: var(--static-gray-900);
                color: var(--static-gray-0);
            }
        }
    }

    /* Color picker */
    ${ColorPickerContainer} {
        background-color: ${({ theme }) => theme['dark-bg']};
    }
    ${DropdownButtonStyle} {
        background: ${({ theme }) => theme['dark-bg']};
        border-color: ${({ theme }) => theme['darker-borders']};
        color: ${({ theme }) => theme.white};
    }
    ${ColorDropdownOptionsContainer} {
        border-color: ${theme['darker-borders']};
        background: ${theme['dark-bg']};

        > div > div {
            background-color: var(--static-gray-900);
            color: var(--static-gray-0);
        }
    }

    /* dividers */
    ${TabSelectorBackground} {
        /* line dividing the tab selector and the rig selector */
        border-color: ${({ theme }) => theme['dark-bg']};
    }
    ${ChannelRelativeContainer} {
        /* line dividing the rig selector and channel selector */
        border-color: var(--static-gray-1000);
    }
    ${ValueStyleContainer} {
        border-color: ${theme['dark-bg']};
    }
    ${UnitStyleContainer} {
        border-color: ${theme['dark-bg']};
    }
    ${FormattingConfigContainer} {
        border-color: ${theme['dark-bg']};
        margin-bottom: 17px;
    }
    .rc-slider-rail {
        background: ${({ theme }) => theme['darker-borders']};
    }
    .rc-slider-dot {
        background: ${({ theme }) => theme['darker-borders']};
    }
    ${PercentageInputContainer} {
        color: ${({ theme }) => theme.white};
        input[type='number'] {
            color: ${({ theme }) => theme.white};
        }
        border-color: ${({ theme }) => theme['darker-borders']};
        background-color: ${({ theme }) => theme['dark-bg']};
    }
    input[type='radio'] {
        background-color: ${({ theme }) => theme['darker-borders']};
    }
    ${MenuContainer} {
        background-color: ${({ theme }) => theme['dark-bg']};
        li a {
            color: ${({ theme }) => theme['input-borders']};
            :hover {
                color: ${({ theme }) => theme.white};
                background-color: ${({ theme }) => theme['auxiliar-typography']};
            }
        }
    }
    .rc-slider-disabled {
        background-color: unset;
    }

    ${LabelBlockedAsset} {
        background-color: var(--static-gray-900);
        color: var(--static-gray-0);
        border: 1px solid var(--static-gray-1000);
    }
`

export default class WidgetTypeActionContainer extends React.Component<ChannelsWidgetTypeActionProps> {
    render() {
        return <DashboardActions changeConfig={this.props.changeConfig} widgetConfig={this.props.widgetConfig} />
    }
}
